import type { BulkReferralRowResult } from '../../../../types/bulk-referral.type';

export type ReconciliationFilter = 'problems' | 'all';

/**
 * Problems when the file has any error, All rows on a fully clean file — never disabled either way.
 * Derived from the rows themselves (not `summary.errorRows`) so this always agrees with what the
 * table and filter bar actually render, even if the aggregate summary ever drifted.
 */
export const defaultFilterFor = (rows: BulkReferralRowResult[]): ReconciliationFilter =>
  rows.some((row) => row.status === 'ERROR') ? 'problems' : 'all';

export const filterRows = (
  rows: BulkReferralRowResult[],
  filter: ReconciliationFilter,
): BulkReferralRowResult[] => (filter === 'problems' ? rows.filter((row) => row.status === 'ERROR') : rows);

/** Raw CSV value for a column, sourced from the row's own errors (unresolved cells have no other raw value). */
export const findRowErrorValue = (row: BulkReferralRowResult, column: string): string | undefined =>
  row.errors.find((error) => error.column === column)?.value;

/** Whether one of the row's errors names this column — drives cell highlighting. */
export const hasRowError = (row: BulkReferralRowResult, column: string): boolean =>
  row.errors.some((error) => error.column === column);

export const formatRole = (role: string): string => {
  if (role === 'SERVICE_PROVIDER') return 'Service Provider';
  if (role === 'FINANCIAL_ADVISOR') return 'Financial Advisor';
  return role;
};
